// 個人中心翻譯

export const personalCenter = {
    title: '個人中心',
    subtitle: '管理您的帳戶、積分、邀請和訂單',
    myCredits: '我的積分',
    myInvites: '我的邀請',
    myOrders: '我的訂單',
    mySubscriptionsTab: '我的訂閱',
    myProfile: {
      title: '我的資料',
      description: '管理您的個人資訊和頭像',
      avatarSettings: '頭像設定',
      basicInformation: '基本資訊',
      loadingProfile: '載入資料中...',
      loadingFailed: '載入失敗',
      retry: '重試',
      uploading: '上傳中...',
      clickToUpload: '點擊上傳',
      cancel: '取消',
      cancelUpload: '取消上傳',
      supportedFormats: '支援 JPG、JPEG、PNG、GIF、WEBP 格式',
      fileSizeLimit: '文件大小不應超過 5MB',
      uploadSuccess: '頭像修改成功'
    },
    userInfo: {
      unknown: '未知',
      googleAccount: 'Google 帳戶',
      emailRegistration: '郵箱註冊',
      unknownMethod: '未知方式',
      verified: '已驗證',
      unverified: '未驗證',
      emailAddress: '郵箱地址',
      registrationMethod: '註冊方式',
      registrationDate: '註冊日期'
    },
    mySubscriptions: {
      title: '我的訂閱',
      description: '管理您的訂閱計劃和帳單',
      loading: '載入訂閱資訊中...',
      retry: '重試',
      noSubscriptions: '暫無活躍訂閱',
      noSubscriptionsDesc: '您目前沒有任何活躍的訂閱。瀏覽我們的方案開始使用。',
      browsePlans: '瀏覽方案',
      price: '價格',
      startDate: '開始日期',
      nextBilling: '下次扣款',
      endDate: '結束日期',
      cancelSubscription: '取消訂閱',
      manageOnPayPal: '在PayPal管理',
      manageOnStripe: '在Stripe管理',
      confirmCancel: '您確定要取消此訂閱嗎？此操作無法撤銷。',
      cancelSuccess: '訂閱已成功取消',
      cancelError: '取消訂閱失敗，請重試。',
      status: {
        active: '活躍',
        cancelled: '已取消',
        suspended: '已暫停',
        expired: '已過期'
      }
    }
  };
